import Hero from "@/sections/Hero";
import Marquee from "@/components/Marquee";
import Chapters from "@/sections/Chapters";
import DestinationGrid from "@/sections/DestinationGrid";
import StaySpotlight from "@/sections/StaySpotlight";
import TravelTools from "@/sections/TravelTools";
import PlanningTimeline from "@/sections/PlanningTimeline";
import JournalList from "@/sections/JournalList";
import Newsletter from "@/components/Newsletter";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <DestinationGrid />
      <Chapters />
      <StaySpotlight />
      <TravelTools />
      <PlanningTimeline />
      <JournalList />
      <Newsletter />
    </div>
  );
}
